import React from 'react';
import Styled from './Navigation.style';
import { Link } from 'react-router-dom';
import { ButtonClean, Icon } from '@savewatersavemoney/swsm-ui';
import { useTranslation } from 'react-i18next';
import { getVariable, isLoggedIn } from '../../helpers';
import * as _ from 'lodash';

const Navigation: React.FC<{
  appWidth: number;
  logOut: Function;
  location: any;
}> = props => {
  const { logOut, appWidth } = props;
  const path = props.location.pathname;
  const swsmInternal = getVariable('mode', 'swsm', false);
  const isDesktop = window.innerWidth > 800;
  const [open, setOpen] = React.useState(false);
  const dropdownRef: any = React.createRef<HTMLElement>();
  const menuRef: any = React.createRef<HTMLElement>();
  const logged = Boolean(isLoggedIn());
  const [t] = useTranslation('common');

  const freepackEnabled = _.get(props, 'app.clientConfig.data.data.freepack_enabled');

  const renderSignIn = () => {
    return (
      <Link
        to="/login"
        style={{
          fontSize: isDesktop ? '20px' : '16px',
          display: 'flex',
          flexDirection: 'row',
          marginLeft: 'auto',
          alignItems: 'center',
          color: '#0b2641',
          textDecoration: 'none',
        }}
      >
        {isDesktop ? <Styled.Text>{t('portal.header.sign_in')}</Styled.Text> : null}{' '}
        <Icon icon="man" size={appWidth < 800 ? 35 : 30} />
      </Link>
    );
  };

  const renderMenus = () => {
    return (
      <>
        <Link
          to="/portal"
          className={path === '/portal' ? 'active' : ''}
          style={{
            fontSize: isDesktop ? '16px' : '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '0px 8px',
          }}
        >
          <Styled.Text onClick={() => (!isDesktop ? setOpen(!open) : null)}>{t('portal.header.menu_home')}</Styled.Text>
        </Link>
        {freepackEnabled && (
          <Link
            to="/free-products"
            className={path === '/free-products' ? 'active' : ''}
            style={{
              fontSize: isDesktop ? '16px' : '20px',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              padding: '0px 8px',
            }}
          >
            <Styled.Text onClick={() => (!isDesktop ? setOpen(!open) : null)}>
              {t('portal.header.menu_freepack')}
            </Styled.Text>
          </Link>
        )}
        <Link
          to="/myuse"
          className={path === '/myuse' ? 'active' : ''}
          style={{
            fontSize: isDesktop ? '16px' : '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '0px 8px',
          }}
        >
          <Styled.Text onClick={() => (!isDesktop ? setOpen(!open) : null)}>
            {t('portal.header.menu_myuse')}
          </Styled.Text>
        </Link>
        <Link
          to="/easywins"
          className={path === '/easywins' ? 'active' : ''}
          style={{
            fontSize: isDesktop ? '16px' : '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '0px 8px',
          }}
        >
          <Styled.Text onClick={() => (!isDesktop ? setOpen(!open) : null)}>
            {t('portal.header.menu_easywins')}
          </Styled.Text>
        </Link>
        <Link
          to="/profile"
          className={path === '/profile' ? 'active' : ''}
          style={{
            fontSize: isDesktop ? '16px' : '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '0px 8px',
          }}
        >
          <Styled.Text onClick={() => (!isDesktop ? setOpen(!open) : null)}>
            {t('portal.header.menu_myProfile')}
          </Styled.Text>{' '}
        </Link>
        <ButtonClean
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            textTransform: 'none',
            fontSize: isDesktop ? '16px' : '20px',
            marginLeft: '8px',
          }}
          onClick={e => {
            e.preventDefault();
            setOpen(false);
            localStorage.setItem('i18nextLng', 'en-GB');
            logOut();
          }}
        >
          <Styled.Text>{t('portal.header.menu_signout')}</Styled.Text>
        </ButtonClean>
        {isDesktop || !swsmInternal ? null : (
          <>
            <div style={{ height: '4px', backgroundColor: '#25B3EB', width: '100%', marginTop: '48px' }}></div>
            <div style={{ display: 'flex', marginTop: '16px' }}>
              <div style={{ marginRight: '32px' }}>
                <Link
                  to="/contact-us"
                  style={{
                    fontSize: '14px',
                    display: 'flex',
                    flexDirection: 'row',
                    paddingBottom: '8px',
                    marginRight: '10px',
                    alignItems: 'center',
                    color: path === '/contact-us' ? ' #174489' : '#0b2641',
                    textDecoration: 'none',
                  }}
                >
                  <Styled.Text onClick={() => (!isDesktop ? setOpen(!open) : null)}>
                    {t('portal.footer.contact_us')}
                  </Styled.Text>{' '}
                </Link>
                <Link
                  to="/terms-and-conditions"
                  style={{
                    fontSize: '14px',
                    display: 'flex',
                    flexDirection: 'row',
                    paddingBottom: '8px',
                    marginRight: '10px',
                    alignItems: 'center',
                    color: path === '/terms-and-conditions' ? ' #174489' : '#0b2641',
                    textDecoration: 'none',
                  }}
                >
                  <Styled.Text onClick={() => (!isDesktop ? setOpen(!open) : null)}>
                    {t('portal.footer.terms')}
                  </Styled.Text>{' '}
                </Link>
                <Link
                  to="/privacy"
                  style={{
                    fontSize: '14px',
                    display: 'flex',
                    flexDirection: 'row',
                    paddingBottom: '8px',
                    marginRight: '10px',
                    alignItems: 'center',
                    color: path === '/privacy' ? ' #174489' : '#0b2641',
                    textDecoration: 'none',
                  }}
                >
                  <Styled.Text onClick={() => (!isDesktop ? setOpen(!open) : null)}>
                    {t('portal.footer.privacy')}
                  </Styled.Text>{' '}
                </Link>
              </div>
              <div>
                <Link
                  to="/cookies"
                  style={{
                    fontSize: '14px',
                    display: 'flex',
                    flexDirection: 'row',
                    paddingBottom: '8px',
                    marginRight: '10px',
                    alignItems: 'center',
                    color: path === '/cookies' ? ' #174489' : '#0b2641',
                    textDecoration: 'none',
                  }}
                >
                  <Styled.Text onClick={() => (!isDesktop ? setOpen(!open) : null)}>
                    {t('portal.footer.cookie')}
                  </Styled.Text>{' '}
                </Link>
                <Link
                  to="/other-policies"
                  style={{
                    fontSize: '14px',
                    display: 'flex',
                    flexDirection: 'row',
                    paddingBottom: '8px',
                    marginRight: '10px',
                    alignItems: 'center',
                    color: path === '/other-policies' ? ' #174489' : '#0b2641',
                    textDecoration: 'none',
                  }}
                >
                  <Styled.Text onClick={() => (!isDesktop ? setOpen(!open) : null)}>
                    {' '}
                    {t('portal.footer.policies')}
                  </Styled.Text>{' '}
                </Link>
                <Link
                  to="/end-user-license-agreement"
                  style={{
                    fontSize: '14px',
                    display: 'flex',
                    flexDirection: 'row',
                    paddingBottom: '8px',
                    marginRight: '10px',
                    alignItems: 'center',
                    color: path === '/end-user-license-agreement' ? ' #174489' : '#0b2641',
                    textDecoration: 'none',
                  }}
                >
                  <Styled.Text onClick={() => (!isDesktop ? setOpen(!open) : null)}>
                    {t('portal.footer.eula')}
                  </Styled.Text>{' '}
                </Link>
              </div>
            </div>
          </>
        )}
      </>
    );
  };

  return (
    <Styled.Menu isDesktop={isDesktop}>
      {logged ? (
        <Styled.Menu>
          {isDesktop ? (
            renderMenus()
          ) : (
            <div ref={menuRef}>
              <Styled.StyledBurger className={open ? 'active' : null} ref={dropdownRef} onClick={() => setOpen(!open)}>
                <div />
                <div />
                <div />
              </Styled.StyledBurger>
              <Styled.StyledMenu ref={dropdownRef} className={open ? 'open' : null}>
                {renderMenus()}
              </Styled.StyledMenu>

              <Styled.Overlay style={open ? { display: 'block' } : { display: 'none' }} />
            </div>
          )}
        </Styled.Menu>
      ) : (
        renderSignIn()
      )}
    </Styled.Menu>
  );
};

export default Navigation;
